// extracted by mini-css-extract-plugin
export default {"social":"bottom_social__+QLgC","icon":"bottom_icon__VWs0Z","btnBackground":"bottom_btnBackground__U7UY4"};